import DEFAULT_LOCALE from 'client/constants/locale'
import { useCallback } from 'react'
import useConfig from './useConfig'
import { useAsyncError } from './useAsyncError'

export const useDateFormatters = () => {
  const config = useConfig()
  const locale = config?.entity?.locale ?? DEFAULT_LOCALE
  const throwError = useAsyncError()

  const formatDate = useCallback((date: Date, options: Intl.DateTimeFormatOptions = {}) => {
    try {
      return new Intl.DateTimeFormat(locale, options).format(date)
    } catch (e) {
      throwError(e, 'Error trying to format an invalid date')
      return '' // satisfy the linter
    }
  }, [locale, throwError])

  return {
    formatDate,
  }
}
